import {
  BrowseTabsLayoutContent,
  type BrowseTabsLayoutContentTab,
} from "#browse-tabs-layout-content";

export function BrowseTabsLayout({
  index,
  tabs,
}: {
  index: string;
  tabs: BrowseTabsLayoutContentTab[];
}) {
  return <BrowseTabsLayoutContent index={index} tabs={tabs} />;
}
